import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Book from './book';
import Gallery from './gallery';
import Login from './login';
import Admin from './admin';
import ProtectedRoute from './ProtectedRoute';
import AdminDPHU from './DPHU/admin';
import AdminKISA from './KISANGANI/admin';
import AdminGOMA from './GOMA/admin';
import AdminKAL from './UNIKAL/admin';
import AdminMUKEDI from './MUKEDI/admin';
import AdminUNIM from './UNIM/admin';
import AdminISTAM from './ISTAM/admin';
import AdminUND from './UND/admin';
import AdminUNCR from './UNCR/admin';
import AdminCIERHA from './CIERHA/admin';
import Super from './super';
import Gen from './MUKEDI/generate';
import Option from './option';
import SearchDoc from './search';
import Student_srch from './student';
import FaviconWrapper from './FaviconWrapper';

const router = createBrowserRouter([
  {
    path: "/",
    element: <Option />,
  },
  {
    path: "academic",
    element: <Book />,
  },
  {
    path: "gallery",
    element: <Gallery />
  },
  {
    path: "login",
    element: <Login />
  },
  {
    path: "gen",
    element: <Gen/>
  },
  {
    path: "Option",
    element: <Option />,
  },
  {
    path: "Student",
    element: <Student_srch />,
  },
  {
    path: "admin",
    element: (
      <FaviconWrapper>
        <ProtectedRoute allowedRole="/admin">
          <Admin/>
        </ProtectedRoute>
      </FaviconWrapper>
    ),
  },
  {
    path: "adminDPHU",
    element: (
      <FaviconWrapper>
        <ProtectedRoute allowedRole="/adminDPHU">
          <AdminDPHU/>
        </ProtectedRoute>
      </FaviconWrapper>
    ),
  },
  {
    path: "adminKISA",
    element: (
      <FaviconWrapper>
        <ProtectedRoute allowedRole="/adminKISA">
          <AdminKISA/>
        </ProtectedRoute>
      </FaviconWrapper>
    ),
  },
  {
    path: "adminGOMA",
    element: (
      <FaviconWrapper>
        <ProtectedRoute allowedRole="/adminGOMA">
          <AdminGOMA/>
        </ProtectedRoute>
      </FaviconWrapper>
    ),
  },
  {
    path: "adminUNIKAL",
    element: (
      <FaviconWrapper>
        <ProtectedRoute allowedRole="/adminUNIKAL">
          <AdminKAL/>
        </ProtectedRoute>
      </FaviconWrapper>
    ),
  },
  {
    path: "adminMUKEDI",
    element: (
      <FaviconWrapper>
        <ProtectedRoute allowedRole="/adminMUKEDI">
          <AdminMUKEDI/>
        </ProtectedRoute>
      </FaviconWrapper>
    ),
  },
  {
    path: "adminUNIM",
    element: (
      <FaviconWrapper>
        <ProtectedRoute allowedRole="/adminUNIM">
          <AdminUNIM/>
        </ProtectedRoute>
      </FaviconWrapper>
    ),
  },
  {
    path: "adminISTAM",
    element: (
      <FaviconWrapper>
        <ProtectedRoute allowedRole="/adminISTAM">
          <AdminISTAM/>
        </ProtectedRoute>
      </FaviconWrapper>
    ),
  },
  {
    path: "adminUND",
    element: (
      <FaviconWrapper>
        <ProtectedRoute allowedRole="/adminUND">
          <AdminUND/>
        </ProtectedRoute>
      </FaviconWrapper>
    ),
  },
  {
    path: "adminUNCR",
    element: (
      <FaviconWrapper>
        <ProtectedRoute allowedRole="/adminUNCR">
          <AdminUNCR/>
        </ProtectedRoute>
      </FaviconWrapper>
    ),
  },
  {
    path: "adminCIERHA",
    element: (
      <FaviconWrapper>
        <ProtectedRoute allowedRole="/adminCIERHA">
          <AdminCIERHA/>
        </ProtectedRoute>
      </FaviconWrapper>
    ),
  },
  {
    path: "superadmin",
    element: (
      <ProtectedRoute allowedRole="/0ADMIN0">
        <Super/>
      </ProtectedRoute>
    ),
  },
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <RouterProvider router = { router }/>
);
reportWebVitals();
